// api.js
import { denormalisedResponseEntities } from '../../util/data';

export const fetchSubscriptionFinal = async (sdk, id) => {
  const response = await sdk.newSdk.subscriptions.show({
    id,
    include: ['listing', 'provider', 'listing.images', 'deliveryToProvider']
  });
  // Zgodnie z ustaleniami: wrzucamy cały response
  return denormalisedResponseEntities(response)[0];
};

export const pickupSubscription = async (sdk, id) => {
  const response = await sdk.newSdk.subscriptions.update({
    id,
    pickup: {} // Trigger przejścia na wydanie produktu
  });
  return denormalisedResponseEntities(response)[0];
};

export const completeSubscription = async (sdk, id) => {
  const response = await sdk.newSdk.subscriptions.update({
    id,
    complete: {} // Trigger przejścia na zakończenie
  });
  return denormalisedResponseEntities(response)[0];
};

// Inicjalizacja procesu zmiany karty
export const initiatePaymentUpdate = async (sdk, id) => {
  const response = await sdk.newSdk.subscriptions.update({
    id,
    initiatePaymentMethodUpdate: {}
  });
  return response.data.data; // Zwraca subskrypcję z nowym setupIntent
};

// Potwierdzenie sukcesu w Stripe na serwerze KDS
export const syncSubscriptionPayment = async (sdk, id) => {
  const response = await sdk.newSdk.subscriptions.update({
    id,
    syncPayment: {}
  });
  return response.data.data;
};

export const cancelSubscription = (sdk, id) => {
  return sdk.newSdk.subscriptions.update({
    id,
    cancel: {} // Zgodnie z Twoim opisem
  });
};